import React from 'react';
import CursoCard from './CursoCard';

const Carrusel = ({ cursos = [] }) => {
  // Mezcla el array de cursos de forma aleatoria
  const cursosAleatorios = cursos.sort(() => Math.random() - 0.5);

  // Limita el número de cursos a 6
  const cursosMostrados = cursosAleatorios.slice(0, 3);

  return (
    <div className="container p-4">
      {/* Grid responsive */}
      <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {cursosMostrados.map((curso, index) => (
          <div key={index}>
            <CursoCard {...curso} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Carrusel;